import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Send } from "lucide-react";
import { api } from "@/lib/api";
import { Logo } from "@/components/common";

export function AuthShell({ title, subtitle, children, testid }) {
  const [tg, setTg] = useState("");
  useEffect(() => { api.get("/settings/public").then((r) => setTg(r.data.telegram_url)).catch(() => {}); }, []);
  const support = tg || "https://t.me/shroud789";
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white" data-testid={testid}>
      <div className="hidden lg:flex flex-col justify-between bg-slate-900 p-12 relative overflow-hidden">
        <Logo onDark />
        <div className="relative z-10">
          <h2 className="font-heading text-3xl font-bold text-white leading-tight">
            Manage Your USDT.<br /><span className="text-blue-400">Track Every Transaction.</span>
          </h2>
          <p className="mt-4 text-slate-400 max-w-sm">A transparent, server-backed ledger for USDT deposits, sell orders and INR payouts.</p>
        </div>
        <div className="text-xs text-slate-500 relative z-10">Secure · Audited · Transparent</div>
        <div className="absolute -right-20 -bottom-20 w-80 h-80 bg-blue-600/20 rounded-full blur-3xl" />
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8"><Logo /></div>
          <h1 className="font-heading text-2xl font-bold text-slate-900">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-slate-600">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          <div className="mt-8 pt-6 border-t border-slate-200 text-center">
            <a href={support} target="_blank" rel="noopener noreferrer" data-testid="auth-contact-support"
              className="inline-flex items-center gap-2 text-sm font-medium text-[#229ED9] hover:underline">
              <Send className="w-4 h-4" /> Contact Support
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-sm font-medium text-slate-700">{label}</span>
      <div className="mt-1.5">{children}</div>
    </label>
  );
}

export const inputClass =
  "w-full px-4 py-2.5 rounded-xl border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition text-slate-900";

export const btnClass =
  "w-full px-4 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700 transition disabled:opacity-60 inline-flex items-center justify-center gap-2";

export function AuthLink({ to, children }) {
  return <Link to={to} className="text-blue-600 font-medium hover:underline">{children}</Link>;
}
